import { FC } from 'react'
import Orders from './components/orders/orders'
import { Tabs } from 'antd'
import PageLayout from '../../../components/page-layout/page-layout'
import { TabsProps } from 'antd/lib'
import Receipts from './components/receprs/recepts'
import styled from 'styled-components'
import useRouteTab from '../../../hooks/use-route-tab'
import { dynamicRoutes } from '../../../constants/routes'

const TabsStyled = styled(Tabs)`
    .ant-tabs-content {
        height: 100% !important;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
        height: 100% !important;
        display: flex;
        flex-direction: column;
    }
`

const TabsData: TabsProps['items'] = [
    {
        label: `Заявки`,
        key: 'requests',
        children: <Orders />,
    },
    {
        label: `Заказы`,
        key: 'receipts',
        children: <Receipts />,
    },
]

const tabs = ['requests', 'receipts'] as const

interface MaterialOrdersPageProps {}

const MaterialOrdersPage: FC<MaterialOrdersPageProps> = () => {
    const { activeKey, onTabChange } = useRouteTab({
        tabs,
        defaultTab: 'requests',
        getRoute: dynamicRoutes.purchasesMaterialOrdersTab,
    })

    return (
        <PageLayout title={'Закупки материалов'}>
            <TabsStyled
                activeKey={activeKey}
                onChange={onTabChange}
                type='card'
                size={'large'}
                items={TabsData}
                style={{ flex: '1 1' }}
                destroyInactiveTabPane
            />
        </PageLayout>
    )
}

export default MaterialOrdersPage
